import { erpAxios } from '.';

const getOfficerData = async (email) => {
  const { data } = await erpAxios.get(`/getOfficerData/${email}`);
  return data;
};

export default getOfficerData;